import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mdp-Globe"
}
const _hoisted_2 = { class: "button-content" }

import { UserSettings } from "@medapro-types/common/rootstate";
import getBrowserLocale from "@util/i18n/get-browser-locale";
import { getSupportedLocales } from "@util/i18n/supported-locales";
import { computed, onMounted, reactive, watch, unref } from "vue";
import { useI18n } from "vue-i18n";
import { useActions, useState } from "vuex-composition-helpers";

type ViewModel = { settings: Pick<UserSettings, "CurrentLocale"> };

export default /*#__PURE__*/_defineComponent({
  __name: 'LocaleSwitcher',
  props: {
    showIcon: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



//#region General
const { locale } = useI18n({ useScope: "global" });
//#endregion

//#region Store
const { userSettings } = useState(["userSettings"]);
const { saveUserSettings } = useActions(["saveUserSettings"]);
//#endregion

//#region ViewModel
const vm = reactive<ViewModel>({ settings: { CurrentLocale: getBrowserLocale() ?? "en" } });
//#endregion

const handleLocaleSwitch = (localeCode: string) => {
  vm.settings.CurrentLocale = localeCode;
  locale.value = localeCode;
};

const locales = computed(() => {
  return getSupportedLocales();
});
const displayLanguageText = computed(() => {
  const displayName = locales.value.find((x) => x.code == locale.value)?.name ?? "";
  return displayName;
});

watch(
  () => vm.settings,
  (nv) => {
    saveUserSettings(nv);
  },
  { deep: true }
);
watch(
  () => userSettings.value,
  (nv) => {
    if (!nv) return;
    Object.assign(vm.settings, {
      CurrentLocale: nv.CurrentLocale
    });
  },
  { immediate: true, deep: true }
);

onMounted(() => {
  locale.value = vm.settings.CurrentLocale;
});

return (_ctx: any,_cache: any) => {
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")!
  const _component_b_dropdown = _resolveComponent("b-dropdown")!

  return (_openBlock(), _createBlock(_component_b_dropdown, {
    class: "dropdown-language-group",
    right: "",
    size: "sm",
    "toggle-class": "mono text-uppercase dropdown-toggle-group",
    "data-cy": "app-settings-interface-lang-ddn"
  }, {
    "button-content": _withCtx(() => [
      (props.showIcon)
        ? (_openBlock(), _createElementBlock("i", _hoisted_1))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_2, _toDisplayString(displayLanguageText.value), 1)
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locales.value, (localeElem) => {
        return (_openBlock(), _createBlock(_component_b_dropdown_item, {
          active: localeElem.code == unref(_unref(locale)),
          key: localeElem.code,
          onClick: ($event: any) => (handleLocaleSwitch(localeElem.code))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(localeElem.name), 1)
          ]),
          _: 2
        }, 1032, ["active", "onClick"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})